import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=2b131e3a&scoped=true&"
import script from "./news-list.vue?vue&type=script&lang=js&"
export * from "./news-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b131e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b131e3a')) {
      api.createRecord('2b131e3a', component.options)
    } else {
      api.reload('2b131e3a', component.options)
    }
    module.hot.accept("./news-list.vue?vue&type=template&id=2b131e3a&scoped=true&", function () {
      api.rerender('2b131e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/news/news-list.vue"
export default component.exports